var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.infoCard},_vm._l((_vm.info),function(item){return _c('div',{key:item.name,class:_vm.$style.infoItem,attrs:{"title":item.content}},[_c('span',{class:_vm.$style.name},[_vm._v(_vm._s(item.name)+"：")]),_vm._t("default",function(){return [_c('span',[_vm._v(" "+_vm._s(item.content)+" ")])]},{"info":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }